import { render, staticRenderFns } from "./RatingsViewerRetrying.vue?vue&type=template&id=b15d725e"
import script from "./RatingsViewerRetrying.vue?vue&type=script&lang=ts"
export * from "./RatingsViewerRetrying.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports